/* eslint-disable no-underscore-dangle */
import React from 'react';
import { Link } from 'react-router-dom';
import { useTransactions } from 'src/hooks/queries/transactions';
import Loading from 'src/Components/Loading';
import TransactionItem from 'src/Components/TransactionItem';
import { InView } from 'react-intersection-observer';
import PlusIcon from './assets/plus.svg';
import HomeWrapper from './styles';

const Home: React.FC = () => {
	const {
		data: transactionsData,
		isLoading,
		fetchNextPage,
		hasNextPage,
		isFetchingNextPage,
	} = useTransactions();

	const handleInViewChange = (isInView: boolean) => {
		if (isInView) {
			fetchNextPage();
		}
	};

	console.log(transactionsData);

	return (
		<HomeWrapper>
			<div className='transactions-list'>
				{!isLoading &&
					transactionsData?.pages?.length > 0 &&
					transactionsData?.pages.map((page: any) =>
						page.data.map((transaction: any) => (
							<TransactionItem
								key={transaction._id}
								transaction={transaction}
							/>
						)),
					)}
				{isLoading && <Loading center size={25} />}
				{!isLoading && hasNextPage && (
					<InView as='div' onChange={handleInViewChange}>
						<button
							type='button'
							className='loadmore-button'
							onClick={() => fetchNextPage()}
							disabled={isFetchingNextPage}
						>
							{isFetchingNextPage ? (
								<Loading center size={15} />
							) : (
								'نمایش بیشتر'
							)}
						</button>
					</InView>
				)}
			</div>
			<Link id='add-transaction' to='/add'>
				<img src={PlusIcon} alt='' />
			</Link>
		</HomeWrapper>
	);
};

export default Home;
